<div class="dtf-accountdetails">
  <!-- <h1 mat-dialog-title>{{ 'LoginModal.AccountRegistration' | translate }}</h1> -->
<mat-dialog-content>
  @if(this.admindialog ==='one'){
    <h2><b>Admin Portal</b></h2>
    <p>Admin Successfully Created</p>
  }
  @if(this.admindialog ==='two'){
    <h2><b>Admin Portal</b></h2>
    <p>Admin Successfully Modified</p>
  } 
  @if(this.admindialog ==='error'){
    <h2><b>Error</b></h2>
    <p><b>{{errorMessage}}</b></p>
}
</mat-dialog-content>

<mat-dialog-actions>
  <!-- @if(this.admindialog ==='one' || this.admindialog ==='two' ||this.admindialog ==='error'){ -->
    <button mat-button mat-dialog-close>Continue</button>
  <!-- } -->
</mat-dialog-actions>

</div>